import Vue from "vue";
import Router from "vue-router";
import { membershipService } from "../_services";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  base: process.env.BASE_URL,
  routes: [
    // ======================
    // Blank Layout
    // ======================
    {
      path: "",
      component: () => import("../layout/blank/Blank.vue"),
      // ======================
      // Theme routes / pages
      // ======================
      children: [
        {
          path: "/",
          redirect: "/login",
          meta: {
            authRequired: false,
          },
        },
        {
          path: "/login",
          name: "Login",
          index: 1,
          meta: {
            authRequired: false,
            authorize: ["*"],
            membership: ["*"],
          },
          component: () => import("../views/authentication/Login.vue"),
        },
        {
          path: "/error404",
          name: "Error 404",
          index: 2,
          meta: {
            authRequired: false,
            authorize: ["*"],
            membership: ["*"],
          },
          component: () => import("../views/authentication/Error404.vue"),
        },
        {
          path: "/privacy",
          name: "Privacy Policy",
          index: 4,
          meta: {
            authRequired: false,
            authorize: ["*"],
            membership: ["*"],
          },
          component: () => import("../views/authentication/Privacy.vue"),
        },
        {
          path: "/terms",
          name: "Terms & Conditions",
          index: 5,
          meta: {
            authRequired: false,
            authorize: ["*"],
            membership: ["*"],
          },

          component: () => import("../views/authentication/Terms.vue"),
        },
      ],
    },
    {
      // ======================
      // Full Layout
      // ======================
      path: "",
      component: () => import("../layout/full/MainContainer.vue"),
      // ======================
      // Theme routes / pages
      // ======================
      children: [
        {
          path: "/customers",
          name: "Menu.Customers",
          index: 6,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Customers",
                active: true,
              },
            ],
          },
          component: () => import("../views/customers/Index.vue"),
        },
        {
          path: "/business/:id",
          name: "Menu.Business",
          index: 7,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Business",
                active: true,
              },
            ],
          },
          component: () => import("../views/customers/edit.vue"),
        },
        {
          path: "/customers/show/:id",
          name: "Customer.ShowCustomerVue.Title",
          index: 8,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Customers",
                url: "/customers",
              },
              {
                title: "Customer.ShowCustomerVue.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/customers/Show.vue"),
        },
        {
          path: "/kiosks/show/:id",
          name: "Customer.ShowCustomerVue.HistoriqueKiosk",
          index: 821,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Monitoring",
                url: "/settings/monitoring",
              },
              {
                title: "Customer.ShowCustomerVue.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/monitoring/Show.vue"),
        },

        {
          path: "/display/show/:id",
          name: "Customer.ShowCustomerVue.HistoriqueDisplay",
          index: 829,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Customers",
                url: "/customers",
              },
              {
                title: "Customer.ShowCustomerVue.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/monitoring/DisplayShow.vue"),
        },



        {
          path: "/customers/:id/update",
          name: "Customer.UpdateCustomerVue.Title",
          index: 9,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Customers",
                url: "/customers",
              },
              {
                title: "Customer.UpdateCustomerVue.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/customers/Update.vue"),
        },

        {
          path: "/customers/:id/update/:uid",
          name: "Customer.UpdateCustomerVue.Title",
          index: 24,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Customers",
                url: "/customers",
              },
              {
                title: "Customer.UpdateCustomerVue.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/customers/UpdateUser.vue"),
        },
        {
          path: "/showmember/:id",
          name: "Menu.Customers",
          index: 10,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Customers",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/show.vue"),
        },
        {
          path: "/dashboard",
          name: "Menu.Dashboard",
          index: 11,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Dashboard",
                active: true,
              },
            ],
          },
          component: () => import("../views/dashboard/Index.vue"),
        },
        {
          path: "/feedback",
          name: "Menu.Feedback",
          index: 12,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Feedback",
                active: true,
              },
            ],
          },
          component: () => import("../views/feedback/Index.vue"),
        },

        {
          path: "/feedbacktest",
          name: "name2",
          component: () => import("../views/feedback/Show.vue"),
        },

        {
          path: "/statistics",
          name: "Menu.Statistics",
          index: 13,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Statistics",
                active: true,
              },
            ],
          },
          component: () => import("../views/statistics/Index.vue"),
        },
        {
          path: "/settings/team",
          name: "Menu.SettingsTeam",
          index: 14,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Settings",
                url: "/settings",
              },
              {
                title: "Menu.SettingsTeam",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Team.vue"),
        },
        {
          path: "/settings/membership",
          name: "Menu.SettingsMembership",
          index: 15,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Settings",
                url: "/settings",
              },
              {
                title: "Menu.SettingsMembership",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Membership.vue"),
        },
        {
          path: "/sms",
          name: "Menu.SettingsSms",
          index: 16,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
            
              {
                title: "Menu.SettingsSms",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Sms.vue"),
        },
        {
          path: "/services",
          name: "Menu.Services",
          index: 16,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
             
              {
                title: "Menu.Services",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Services.vue"),
        },
        {
          path: "/industries",
          name: "Menu.Industries",
          index: 16,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
           
              {
                title: "Menu.Industries",
                active: true,
              },
            ],
          },
          component: () => import("../views/Industry/Index.vue"),
        },

        {
          path: "/regions",
          name: "Menu.Regions",
          index: 27,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
           
              {
                title: "Menu.Regions",
                active: true,
              },
            ],
          },
          component: () => import("../views/Regions/Index.vue"),
        },

        {
          path: "/request-tt",
          name: "Menu.RequestTT",
          index: 28,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
           
              {
                title: "Menu.RequestTT",
                active: true,
              },
            ],
          },
          component: () => import("../views/RequestTT/Index.vue"),
        },

        {
          path: "/request-tt/show/:id",
          name: "Menu.RequestTT",
          index: 29,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.RequestTT",
                url: "/request-tt",
              },
              {
                title: "Menu.RequestTT",
                active: true,
              },
            ],
          },
          component: () => import("../views/RequestTT/Show.vue"),
        },

        {
          path: "/organizations",
          name: "Menu.Organizations",
          index: 17,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Organizations",
                active: true,
              },
            ],
          },
          component: () => import("../views/organizations/Index.vue"),
        },


        {
          path: "/organizations/create",
          name: "Organization.OrganizationAdd.Title",
          index: 18,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Organizations",
                url: "/organizations",
              },
              {
                title: "Organization.OrganizationAdd.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/organizations/Create.vue"),
        },
        {
          path: "/organizations/show/:id",
          name: "Organization.OrganizationShow.Title",
          index: 19,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Organizations",
                url: "/organizations",
              },
              {
                title: "Organization.OrganizationShow.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/organizations/Show.vue"),
        },
        {
          path: "/organizations/update/:id",
          name: "Organization.OrganizationUpdate.Title",
          index: 19,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Organizations",
                url: "/organizations",
              },
              {
                title: "Organization.OrganizationUpdate.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/organizations/Update.vue"),
        },
        {
          path: "/harif_sms_gateways",
          name: "Menu.Harif",
          index: 19.1,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Harif",
                active: true,
              },
            ],
          },
          component: () => import("../views/smsGateways/Index.vue"),
        },
        // Payment methods
        {
          path: "/payment_methods",
          name: "Menu.paymentMethods",
          index: 6.9,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.paymentMethods",
                active: true,
              },
            ],
          },
          component: () => import("../views/paymentMethods/Index.vue"),
        },
        // Reseller part
        {
            path: "/resellers",
            name: "Menu.Reseller",
            index: 25,
            meta: {
              authRequired: true,
              authorize: ["*"],
              membership: ["*"],
              breadcrumb: [
                {
                  title: "Menu.Reseller",
                  active: true,
                },
              ],
            },
            component: () => import("../views/resellers/Index.vue"),
        },
        {
          path: "/reseller/:id/update",
          name: "Reseller.UpdateTitle",
          index: 26,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Reseller",
                url: "/resellers",
              },
              {
                title: "Reseller.UpdateTitle",
                active: true,
              },
            ],
          },
          component: () => import("../components/reseller/Update.vue"),
        },

        {
          path: "/harif_sms_gateways/create",
          name: "Harif.Add.Title",
          index: 18.5,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Harif",
                url: "/harif_sms_gateways",
              },
              {
                title: "Harif.Add.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/smsGateways/Create.vue"),
        },
        {
          path: "/harif_sms_gateways/update/:id",
          name: "Harif.Update.Title",
          index: 19,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Harif",
                url: "/harif_sms_gateways",
              },
              {
                title: "Harif.Update.Title",
                active: true,
              },
            ],
          },
          component: () => import("../views/smsGateways/Update.vue"),
        },
        {
          path: "/settings/ticket",
          name: "Menu.SettingsTicket",
          index: 20,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Settings",
                url: "/settings",
              },
              {
                title: "Menu.SettingsTicket",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Ticket.vue"),
        },

        {
          path: "settings/monitoring",
          name: "Pings.Monitoring",
          index: 17,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Settings",
                url: "/settings",
              },

              {
                title: "Pings.Monitoring",
                active: true,
              },
            ],
          },
          component: () => import("../views/monitoring/Monitor.vue"),
        },
        {
          path: "/settings/terms",
          name: "Kiosk.Table.Terms",
          index: 21,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Settings",
                url: "/settings",
              },
              {
                title: "Kiosk.Table.Terms",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Terms.vue"),
        },
        {
          path: "/settings/policy",
          name: "Kiosk.Table.Policy",
          index: 21,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Settings",
                url: "/settings",
              },
              {
                title: "Kiosk.Table.Policy",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Policy.vue"),
        },
        {
          path: "/settings/advertisement",
          name: "Menu.SettingsAdvertisement",
          index: 21,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Settings",
                url: "/settings",
              },
              {
                title: "Menu.SettingsAdvertisement",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Advertisement.vue"),
        },
        {
          path: "/settings/mobile",
          name: "Menu.SettingsMobile",
          index: 22,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.Settings",
                url: "/settings",
              },
              {
                title: "Menu.SettingsMobile",
                active: true,
              },
            ],
          },
          component: () => import("../views/settings/Mobile.vue"),
        },

        {
          path: "/business_requests",
          name: "Menu.BusinessRequests",
          index: 23,
          meta: {
            authRequired: true,
            authorize: ["*"],
            membership: ["*"],
            breadcrumb: [
              {
                title: "Menu.BusinessRequests",
                active: true,
              },
            ],
          },
          component: () => import("../views/businessRequests/Index.vue"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/Error404",
    },
  ],
});

import NProgress from "nprogress";

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const userLoggedIn = JSON.parse(localStorage.getItem("user"));

  if (to.meta.authRequired && !userLoggedIn) {
    if (!userLoggedIn) {
      localStorage.setItem("user", null);
    }
    return next("/login");
  }
  if (to.fullPath == "/login" && userLoggedIn) {
    if (!userLoggedIn) {
      localStorage.setItem("user", null);
    }
    return next("/dashboard");
  }
  if (
    userLoggedIn &&
    !(
      to.meta.authorize.find((obj) => obj == userLoggedIn.user.role) ||
      to.meta.authorize.find((obj) => obj == "*")
    )
  ) {
    return next("/Error404");
  }
  next();
});

router.beforeResolve(async (to, from, next) => {
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});
export default router;
